import { __awaiter, __decorate, __generator } from "tslib";
import { observable, computed, makeObservable } from 'mobx';
import { UserRepo } from '../../Repositories/UserRepo';
var UserStore = /** @class */ (function () {
    function UserStore(rootStore) {
        Object.defineProperty(this, "ucfStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loggedIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isSubUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                email: '',
                password: '',
            }
        });
        Object.defineProperty(this, "signupBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
            }
        });
        Object.defineProperty(this, "resetPasswordInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                data: {
                    key: '',
                    new_password: '',
                },
            }
        });
        makeObservable(this);
        this.ucfStore = rootStore;
    }
    Object.defineProperty(UserStore.prototype, "isLoggedIn", {
        get: function () {
            return this.loggedIn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "login", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var logged;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserRepo.login(this.ucfStore, this.loginBody)];
                        case 1:
                            logged = _a.sent();
                            if (logged) {
                                this.setAuth();
                                this.setToken(logged);
                                return [2 /*return*/, true];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "signup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var signed;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserRepo.signup(this.ucfStore, this.signupBody)];
                        case 1:
                            signed = _a.sent();
                            if (signed) {
                                return [2 /*return*/, true];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "verifyEmail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var verify;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserRepo.verifyEmail(this.ucfStore, id)];
                        case 1:
                            verify = _a.sent();
                            if (verify) {
                                return [2 /*return*/, true];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "sendForgotPasswordEmail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (email) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = {
                                email: email,
                            };
                            return [4 /*yield*/, UserRepo.sendForgotPasswordEmail(this.ucfStore, data)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "sendResetPassword", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var reset;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserRepo.sendResetPassword(this.ucfStore, data)];
                        case 1:
                            reset = _a.sent();
                            if (reset) {
                                return [2 /*return*/, true];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "logout", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setAuth(false);
            this.user = null;
        }
    });
    Object.defineProperty(UserStore.prototype, "setAuth", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isLoggedIn) {
            if (isLoggedIn === void 0) { isLoggedIn = true; }
            this.loggedIn = isLoggedIn;
        }
    });
    Object.defineProperty(UserStore.prototype, "setToken", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (auth) {
            this.user = auth;
        }
    });
    __decorate([
        observable
    ], UserStore.prototype, "ucfStore", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "user", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "loggedIn", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "isSubUser", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "loginBody", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "signupBody", void 0);
    __decorate([
        observable
    ], UserStore.prototype, "resetPasswordInput", void 0);
    __decorate([
        computed
    ], UserStore.prototype, "isLoggedIn", null);
    return UserStore;
}());
export { UserStore };
//# sourceMappingURL=data:application/json;base64,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